export default "__VITE_ASSET__CsiG8bGc__"